module.exports = __webpack_public_path__ + "img/step5-en@2x.8e2ccf0f.webp";